import axios from 'axios';

const reqUrl1 = process.env.NEXT_PUBLIC_RELEVANCE_TAAW_1_API_URL;
const reqUrl2 = process.env.NEXT_PUBLIC_RELEVANCE_TAAW_2_API_URL;

async function createTaaw({
  objective,
  region,
  spo,
  audience,
  isSecond,
}: {
  objective: string;
  region: string;
  spo: string;
  audience: string;
  isSecond: boolean;
}) {
  const { data } = await axios.post(`${isSecond ? reqUrl2 : reqUrl1}/trigger_limited_async`, {
    params: {
      obj: objective,
      region: region,
      spo: spo,
      ta: audience,
    },
    version: 'latest',
    project: '8f8205497a61-4568-b3f2-c46fb2b0bdef',
    studio_id: isSecond
      ? '5f3df53c-1d8d-4174-893f-82e411e1bdd3'
      : '4c3526f3-d491-451e-a7cb-42e502e5e63d',
  });
  return data;
}

async function getTaaw({ jobId, prevData }: { jobId: string; prevData: any }) {
  const params = {
    ending_update_only: false,
    project: '8f8205497a61-4568-b3f2-c46fb2b0bdef',
    sort: '[{"message_id":"desc"}]',
  };

  const { data } = await axios.get(`${prevData ? reqUrl2 : reqUrl1}/async_poll/${jobId}`, {
    params,
  });
  return prevData
    ? { data: data, prevData: prevData, isSecond: true }
    : { data: data, isSecond: false };
}

export const taaws = {
  createTaaw,
  getTaaw,
};
